define('entities/admin/work_activity',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.UserWorkActivityTotal = Backbone.RelationalModel.extend({
    defaults: {
      userpidSecId: null,
      firstName: '',
      lastName: '',
      email: '',
      logonId: '',
      totalMinutes: 0,
      activeDays: 0,
      lastSeen: null
    },
    idAttribute: 'userpidSecId'
  });

  var API = {
    getCanViewUrl: function () {
      return Settings.url('compuzz2', 'v2/userworkactivity/canView');
    },
    getTotalsUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userworkactivity/totals', params);
    },
    getUserDailyUrl: function (userpidSecId, params) {
      return Settings.url('compuzz2', 'v2/userworkactivity/users/' + userpidSecId + '/daily', params);
    },
    getUserStatusChangesUrl: function (userpidSecId, params) {
      return Settings.url('compuzz2',
        'v2/userworkactivity/users/' + userpidSecId + '/status-changes', params);
    },
    getStatusChangesBucketsUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userworkactivity/status-changes-buckets', params);
    },
    getTopMoversUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userworkactivity/top-movers', params);
    },
    getAvailableStatusesUrl: function () {
      return Settings.url('compuzz2', 'v2/userworkactivity/available-statuses');
    }
  };

  function jsonGet(url) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  }

  App.reqres.setHandler('workActivity:canView', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getCanViewUrl(),
      global: false,
      success: function (data) {
        defer.resolve(data && data.canView === true);
      },
      error: function () { defer.resolve(false); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('workActivity:totals', function (from, to) {
    return jsonGet(API.getTotalsUrl({ from: from, to: to }));
  });

  App.reqres.setHandler('workActivity:user-daily', function (userpidSecId, from, to) {
    return jsonGet(API.getUserDailyUrl(userpidSecId, { from: from, to: to }));
  });

  App.reqres.setHandler('workActivity:user-status-changes', function (userpidSecId, from, to) {
    return jsonGet(API.getUserStatusChangesUrl(userpidSecId, { from: from, to: to }));
  });

  App.reqres.setHandler('workActivity:status-changes-buckets', function (from, to, bucket) {
    return jsonGet(API.getStatusChangesBucketsUrl({
      from: from, to: to, bucket: bucket || 'day'
    }));
  });

  App.reqres.setHandler('workActivity:top-movers', function (from, to, status, commandType, limit) {
    var params = { from: from, to: to, status: status, limit: limit || 5 };
    if (commandType) {
      params.commandType = commandType;
    }
    return jsonGet(API.getTopMoversUrl(params));
  });

  App.reqres.setHandler('workActivity:available-statuses', function () {
    return jsonGet(API.getAvailableStatusesUrl());
  });
});

